import Form from "antd/es/form/Form";
import { get } from "http";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Button from "src/Components/Button";
import DynamicMultiSelectDropdown from "src/Components/Dropdown/DynamicMultiSelectDropdown";
import StaticDropdown from "src/Components/Dropdown/StaticDropdown";
import { StaticMultiSelectDropdown } from "src/Components/Dropdown/StaticMultiSelectDropdown";
import Modal from "src/Components/Modal/Modal";
import TextInput from "src/Components/TextInput";
import { IPortfoPairPositionTableReport, IPortfoPairPositionUser } from "src/Interfaces/deltaHedgeAccounts";
import { DeltaHedgeOrderType, IDeltaHedgeOrderFormValues } from "src/Interfaces/deltaHedgeOrder";
import { DropdownItem } from "src/Interfaces/dropdownInterfaces";
import { StepOptionOrderType, StepOrderSide } from "src/Interfaces/stepInterfaces";
import OrderPreviewTable, { isDeltaHedgePreviewRowSendable } from "src/Pages/DeltaHedgeOrder/OrderPreviewTable";
import SahraConnections from "src/Pages/Sahra/SahraConnections";
import { sendOrders } from "src/Requests/adjustment";
import { getDeltaHedgeAccountsDropdown } from "src/Requests/deltaHedgeAccounts";
import { addDeltaHedgeOrder } from "src/Requests/deltaHedgeOrder";
import { getStepInstruments } from "src/Requests/stepRequests";
import { packetErrorHandler } from "src/Utils/requestUtils";

interface IProps {
  row: IPortfoPairPositionTableReport;
  processType: DeltaHedgeOrderType,
    
  onAction: () => void;
}
interface IGetDeltaHedgeOrderDTO
{
    accountIds: number[],
    processType: DeltaHedgeOrderType,
    orderSide1:  StepOrderSide,
    orderSide2:  StepOrderSide,
    
    instrumentId1:string,
    instrumentId2: string,

    instrumentName1:string,
    instrumentName2:string,


    optionOrderType1: StepOptionOrderType,
    optionOrderType2: StepOptionOrderType,

    dailyLockPercent:number,
    blockSize:number,
    marginPercent:number

}

enum ModalMode {
  Closed,
  SahraOrderTable,
  OrderPreview,
}

const SendDeltaOrderRequestConfig = ({ row,processType, onAction }: IProps) => {

  
  const getBaseSide=()=>{  
    if(processType==DeltaHedgeOrderType.Roll)    
      return row.offsetSide;      
    return 1;         
  }

  const getOptionOrderType=(side :number)=>{  

    if(processType==DeltaHedgeOrderType.Offset)    
      return StepOptionOrderType.Offset;      

    if(row.offsetSide==side)
      return StepOptionOrderType.Offset;      
    
    return StepOptionOrderType.Open;        
  }
  
  const getBaseVolume=( user :IPortfoPairPositionUser |null )=>{  

    if(!user)
      return 0;
     
    if(getBaseSide()==1)
      return Math.abs( user?.relatedPortfo.instrumentVolume1 ?? 0);

    return Math.abs( user?.relatedPortfo.instrumentVolume2 ?? 0);
          
  }

  const getrealOrderSide=(orderside:StepOrderSide )=>
  {
    if(processType==DeltaHedgeOrderType.Offset)
    {
      if(orderside==StepOrderSide.Buy)
        return StepOrderSide.Sell;
      return StepOrderSide.Buy;
    }

    return orderside;
     
  }
    
  const  getUserDropdown=()=>{
    return Array.from(
         new Map(
           row.users
             ?.map(x => [x.userId, { id: x.userId, name: x.userName }]) // [key, value] entries
         ).values()
       ) as DropdownItem[];
   }



   const getDailyLockProfit=()=>{

    if(processType==DeltaHedgeOrderType.Offset)
      return (row.dailyLockProfitPercentInstantOffset ?? 0);
    return row.dailyLockProfitPercent;
   }

  const [formValues, setFormValues] = useState({
    accountIds:getUserDropdown().map(x=>parseInt(x.id?.toString())) as number[],
    processType: processType,   
    orderSide1:getrealOrderSide(row.orderSide1Enum),
    orderSide2:getrealOrderSide(row.orderSide2Enum),
    instrumentId1: row.instrumentId1,
    instrumentId2: row.instrumentId2,
    instrumentName1: row.instrumentName1,
    instrumentName2: row.instrumentName2,    
      
    optionOrderType1: getOptionOrderType(1),
    optionOrderType2: getOptionOrderType(2),

    dailyLockPercent: parseFloat(  (getDailyLockProfit()*100).toPrecision(3)),
    blockSize: 100,
    marginPercent:0
  } as IGetDeltaHedgeOrderDTO);
   

  const [instrumentOptions, setInstrumentOptions] = useState(
    [] as DropdownItem[]
  );
  const [modalMode, setModalMode] = useState(ModalMode.Closed);
  const [previewOrders, setPreviewOrders] = useState<IDeltaHedgeOrderFormValues[]>([]);
  const [loading, setLoading] = useState(false);
  const sendableOrders = previewOrders.filter(isDeltaHedgePreviewRowSendable);
  

  const orderTypeDropdown=[
    {id:StepOptionOrderType.Offset,name:"آفست"}as DropdownItem,
    {id:StepOptionOrderType.Open,name:"اپن"}as DropdownItem
  ] ;

  
  const orderSideDropdown=[
    {id:StepOrderSide.Buy,name:"خرید"}as DropdownItem,
    {id:StepOrderSide.Sell,name:"فروش"}as DropdownItem
  ] ;
  useEffect(() => {
    getStepInstruments()
      .then((resp) => {
        setInstrumentOptions(resp);
      })
      .catch(packetErrorHandler);
  }, []);

  const changeHandler = (name: string, value: any) => {
    setFormValues({ ...formValues, [name]: value });
  };

  const sendDeltaHedgeOrders = () => {
    if (loading || !sendableOrders.length) return;
    setLoading(true);
    const requests = sendableOrders.map((order) => addDeltaHedgeOrder(order));
    Promise.all(requests)
      .then(() => {
        toast.success("با موفقیت انجام شد");
        onAction();
        setModalMode(ModalMode.Closed);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };



  const getOrders=()=>{

    const orders= [] as IDeltaHedgeOrderFormValues[];

    const Ids= Array.from(new Set(formValues.accountIds));
    for (const accountId of Ids) {
        const user = row.users.find(x => x.userId == accountId.toString());
      
        const order: IDeltaHedgeOrderFormValues = {
          accountName: user?.userName,
          instrumentName1: formValues.instrumentName1,
          instrumentName2: formValues.instrumentName2,
          accountId: parseInt( accountId.toString()),

          instrumentId1: formValues.instrumentId1,
          instrumentId2: formValues.instrumentId2,
      
          baseVolumeSide: getBaseSide(),
          baseVolume: getBaseVolume(user || null ), // fallback to 0 if missing
      
          blockSize: formValues.blockSize,
          marginInPercent: formValues.marginPercent,
      
          optionOrderType1: formValues.optionOrderType1,
          optionOrderType2: formValues.optionOrderType2,
          

          lockProfitTarget: formValues.dailyLockPercent,
          deltaHedgeOrderType: processType,
          orderSide1: formValues.orderSide1,
          orderSide2: formValues.orderSide2,
        };
      
        orders.push(order);
      }
      
    return orders;
  }

  const sahraUserTableModalUI = (
    <div className="flex flex-col justify-start items-center gap-3">
      <SahraConnections
        initialSearchParam={{
          userIds: sendableOrders.map((order) => order.accountId),
        }}
      />

      <div className="w-[100px] mr-auto">
        <Button text="ثبت" variant="contained" onClick={sendDeltaHedgeOrders} disabled={loading || !sendableOrders.length} />
      </div>
    </div>
  );



  const orderPreviewModalUI = (
    <div className="flex flex-col justify-start items-center gap-3">

       <OrderPreviewTable values={previewOrders} />

      <div className="w-[100px] mr-auto">
        <Button
          text="ثبت"
          variant="contained"
          onClick={() => setModalMode(ModalMode.SahraOrderTable)}
          disabled={loading || !sendableOrders.length}
        />
      </div>
    </div>
  );

  const getModalMode = () => {
    switch (modalMode) {
      case ModalMode.Closed:
        return <></>;

      case ModalMode.SahraOrderTable:
        return sahraUserTableModalUI;

      case ModalMode.OrderPreview:
        return orderPreviewModalUI;

      default:
        return <></>;
    }
  };

    function submitHandler(): void {
        setPreviewOrders(getOrders());
        setModalMode(ModalMode.OrderPreview)
    }

  return (
    <Form className="!w-80 gap-3 p-2 px-2 !mx-auto">
      {modalMode !== ModalMode.Closed ? (
        <Modal
          modalBoxClassName="!min-w-0 w-[1320px]"
          onClose={() => setModalMode(ModalMode.Closed)}
          UI={getModalMode()}
        />
      ) : (
        <></>
      )}

      
      <StaticMultiSelectDropdown      
        label="اکانت ها"
        name="accountIds"
        value={Array.from(new Set(formValues.accountIds.map(x=>x.toString())))}        
        onChange={changeHandler}
        items={getUserDropdown()}
        extraLabel
        withSelectAll
        withTagBox
        
      />
      <StaticDropdown
        onChange={changeHandler}
        dropdown={{
          name: "",
          placeholder: "نماد جهت اول",
          disabled: true,
          extraLabel: true,
        }}
        value={row.instrumentId1}
        options={instrumentOptions}
      />
      <StaticDropdown
        onChange={changeHandler}
        dropdown={{
          name: "",
          placeholder: "نماد جهت دوم",
          disabled: true,
          extraLabel: true,
        }}
        value={row.instrumentId2}
        options={instrumentOptions}
      />

     <StaticDropdown
        onChange={changeHandler}
        dropdown={{
          name: "",
          placeholder: " جهت اول",
          disabled:true,
          extraLabel: true,
        }}
        value={formValues.orderSide1}
        options={orderSideDropdown}
      />
      <StaticDropdown
        onChange={changeHandler}
        dropdown={{
          name: "",
          placeholder: " جهت دوم",
          disabled:true,
          extraLabel: true,
        }}
        value={formValues.orderSide2}
        options={orderSideDropdown}
      />

      <StaticDropdown
        onChange={changeHandler}
        dropdown={{
          name: "",
          placeholder: " نوع معامله اول",
          disabled:true,
          extraLabel: true,
        }}
        value={formValues.optionOrderType1}
        options={orderTypeDropdown}
      />
      <StaticDropdown
        onChange={changeHandler}
        dropdown={{
          name: "",
          placeholder: " نوع معامله دوم",
          disabled:true,
          extraLabel: true,
        }}
        value={formValues.optionOrderType2}
        options={orderTypeDropdown}
      />
      


      
      <TextInput
        label="% بازده قفل پورتفو"
        value={formValues.dailyLockPercent?.toString()}
        name="dailyLockPercent"
        onChange={changeHandler}
        extraLabel
      />

      
        <TextInput
        label="% بلوک"
        value={formValues.blockSize?.toString()}
        name="blockSize"
        onChange={changeHandler}
        extraLabel
      />

        <TextInput
        label="% مارجین"
        value={formValues.marginPercent?.toString()}
        name="marginPercent"
        onChange={changeHandler}
        extraLabel
      />
      <hr/>
      <Button text="ثبت" variant="contained" onClick={submitHandler} />
    </Form>
  );
};

export default SendDeltaOrderRequestConfig;
